module.exports = __webpack_public_path__ + "static/media/FD4.64f78d89.jpg";